<template>
    <div class="container-fluid">
      <div class="w-full rounded overflow-hidden shadow-lg">
          <!-- Contenedor principal para colocar ambas secciones en una fila -->
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="flex  gap-x-0">
              <div class="card" style="flex-grow: 1; width: 100%; height: 100%; flex-shrink: 0; background-color: white; margin: 0; padding: 0;">
                  <!-- Tabs Navigation -->
                  <div class="card-tabs">
                      <div class="flex border-b">
                          <button 
                              @click="activeTab = 'general'" 
                              :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'general'}"
                              class="px-4 py-2 text-neutral-500 font-medium"
                          >
                              General
                          </button>
                          <button 
                              @click="activeTab = 'social'" 
                              :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'social'}"
                              class="px-4 py-2 text-neutral-500 font-medium"
                          >
                              Asesores
                          </button>
                          <button 
                              @click="activeTab = 'propiedades'" 
                              :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'propiedades'}"
                              class="px-4 py-2 text-neutral-500 font-medium"
                          >
                              Propiedades
                          </button>
                          <button 
                              @click="activeTab = 'documentos'" 
                              :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'documentos'}"
                              class="px-4 py-2 text-neutral-500 font-medium"
                          >
                              Documentos
                          </button>
                      </div>
                  </div>
                  <div v-if="activeTab === 'general'" class="w-full h-full p-4 rounded-lg flex">
                      <!-- Sección de perfil a la izquierda -->
                      <div class="flex-0.8 p-4">
                          <div class="card-header text-left py-2">
                              <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                                  Perfil
                              </div>
                          </div>
                          <div class="card-body pt-16">
                              <!-- Foto de perfil -->
                              <div class="user-image flex-grow flex items-center justify-center mb-4">
                                  <input type="file" id="profile_avatar" style="display: none" @change="updateProfileImage" />
                                  <div class="avatar relative">
                                      <img 
                                          :src="imageSrc || defaultProfileImage" 
                                          alt="Avatar" 
                                          id="image_profile" 
                                          class="rounded-full w-26 h-26 mx-auto mb-2" 
                                      />
                                      <!-- Círculo rosa sobre la imagen de perfil -->
                                      <div class="absolute flex items-center justify-center w-full h-full top-0 left-0 z-10">
                                          <!-- Círculo rosa -->
                                          <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" class="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-20">
                                              <circle cx="16.5" cy="16.5" r="16.5" fill="#FF4265"/>
                                          </svg>

                                          <!-- Lápiz centrado dentro del círculo -->
                                          <label for="profile_avatar" class="cursor-pointer absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                  <g clip-path="url(#clip0_2110_2581)">
                                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4649 0.157368C14.3594 0.0519157 14.2164 -0.00732422 14.0672 -0.00732422C13.9181 -0.00732422 13.775 0.0519157 13.6695 0.157368L11.8166 2.01024L15.987 6.18062L17.8399 4.32887C17.8923 4.27662 17.9338 4.21454 17.9622 4.14621C17.9906 4.07787 18.0051 4.00461 18.0051 3.93062C18.0051 3.85663 17.9906 3.78337 17.9622 3.71503C17.9338 3.64669 17.8923 3.58462 17.8399 3.53237L14.4649 0.157368ZM15.1916 6.97599L11.0213 2.80562L3.70877 10.1181H3.94165C4.09083 10.1181 4.2339 10.1774 4.33939 10.2829C4.44488 10.3884 4.50415 10.5314 4.50415 10.6806V11.2431H5.06665C5.21583 11.2431 5.3589 11.3024 5.46439 11.4079C5.56988 11.5134 5.62915 11.6564 5.62915 11.8056V12.3681H6.19165C6.34083 12.3681 6.4839 12.4274 6.58939 12.5329C6.69488 12.6384 6.75415 12.7814 6.75415 12.9306V13.4931H7.31665C7.46583 13.4931 7.6089 13.5524 7.71439 13.6579C7.81988 13.7634 7.87914 13.9064 7.87914 14.0556V14.2885L15.1916 6.97599ZM6.79014 15.3775C6.76647 15.3145 6.75428 15.2479 6.75415 15.1806V14.6181H6.19165C6.04246 14.6181 5.89939 14.5589 5.7939 14.4534C5.68841 14.3479 5.62915 14.2048 5.62915 14.0556V13.4931H5.06665C4.91746 13.4931 4.77439 13.4339 4.6689 13.3284C4.56341 13.2229 4.50415 13.0798 4.50415 12.9306V12.3681H3.94165C3.79246 12.3681 3.64939 12.3089 3.5439 12.2034C3.43841 12.0979 3.37915 11.9548 3.37915 11.8056V11.2431H2.81665C2.74939 11.243 2.68271 11.2308 2.61977 11.2071L2.4184 11.4074C2.36479 11.4614 2.32269 11.5256 2.29465 11.5964L0.0446458 17.2214C0.00372885 17.3236 -0.00628759 17.4356 0.0158383 17.5434C0.0379642 17.6513 0.0912594 17.7503 0.169117 17.8281C0.246974 17.906 0.345969 17.9593 0.45383 17.9814C0.561691 18.0036 0.673674 17.9935 0.775896 17.9526L6.40089 15.7026C6.47162 15.6746 6.53591 15.6325 6.5899 15.5789L6.79014 15.3786V15.3775Z" fill="white"/>
                                                  </g>
                                                  <defs>
                                                  <clipPath id="clip0_2110_2581">
                                                      <rect width="18" height="18" fill="white"/>
                                                  </clipPath>
                                                  </defs>
                                              </svg>
                                          </label>
                                      </div>
                                  </div>
                              </div>
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                                  <label class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                                      {{ (name || '') + ' ' + (last_name || '') }}
                                  </label>
                              </div>
                              
                          </div>
                      </div>
                  
                      <!-- Sección de información personal a la derecha -->
                      <div class="flex-1 p-2">
                          <div class="card-header text-left py-2">
                            <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                                Información Personal
                            </div>
                          </div>
                          <div class="p-2 flex flex-col-2">
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Ingresa tu nombre</label>
                              <fwb-input
                                  v-model="name"
                                  labelStyle="text-style-sm"
                                  size="sm"
                                  class="w-full bg-white text-box "
                              />
                              </div>

                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                                <div class="w-full">
                                    <label class="text-style-sm mb-1 block text-sm font-medium text-gray-900 dark:text-white">
                                      Fecha de nacimiento
                                    </label>
                                    <div class="flex relative ">
                                      <VueDatePicker
                                        v-model="birthday"
                                        class="text-box bg-white"
                                        :format="format"
                                        :locale="es" 
                                      />
                                    </div>
                                </div>
                              </div>
                          </div>

                          <div class="p-2 flex flex-col-2">
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                                <label class="text-style-sm mb-1">Apellido paterno</label>
                                  <fwb-input
                                      v-model="last_name"
                                      placeholder="Ingresa tu apellido paterno"
                                      size="sm"
                                      class="w-full bg-white text-box"
                                  />
                              </div>
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                                <label class="text-style-sm mb-1">Apellido Materno</label>
                                  <fwb-input
                                      v-model="last_second_name"
                                      placeholder="Ingresa tu apellido materno"
                                      size="sm"
                                      class="w-full bg-white text-box"
                                  />
                              </div>
                          </div>

                          <div class="p-2 flex flex-col-2">
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Email</label>
                              <fwb-input
                                  v-model="email"
                                  required
                                  placeholder="Ingresa tu email"
                                  class="w-full bg-white text-box"
                              />
                              </div>
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Teléfono</label>
                              <fwb-input
                                  v-model="phone"
                                  required
                                  placeholder="Ingresa tu teléfono"
                                  class="w-full bg-white text-box"
                              />
                              </div>
                          </div>
                          
                          <div class="row">

                              <div class="p-2 flex flex-col-2">
                                <div class="flex flex-1 flex-col p-2 text-gray-900">
                                    <label class="text-style-sm mb-1">Asesor *</label>
                                    <select 
                                      class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" 
                                      v-model="advisor_id">  // Changed from user.advisor_id to advisor_id
                                      <option value="" disabled>
                                          {{ userId ? 'Selecciona una opción' : 'Selecciona un asesor' }}
                                      </option>
                                      <option 
                                          v-for="advisor in dic_advisors" 
                                          :key="advisor.id" 
                                          :value="advisor.id">
                                          {{ advisor.name }}
                                      </option>
                                  </select>
                                </div>
                                <!-- Otro Cargo -->
                                <div class="flex flex-1 flex-col p-2 text-gray-900">
                                    <label class="text-style-sm mb-1">Genero</label>
                                    <select class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" v-model="user.position_id">
                                    <option value="0">Selecciona un cargo</option>
                                    <option v-for="cargo in cargos" :key="cargo.id" :value="cargo.id">
                                        {{ cargo.name }}
                                    </option>
                                    </select>
                                </div>
                              </div>
                          </div>
                          <div class="p-2 flex flex-col">
                              <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <!-- Agregar checkbox para bloquear -->
                              <label class="text-box mb-1">
                                  <input
                                  type="checkbox"
                                  id="block_user" 
                                  v-model="blockUser" 
                                  class="form-check-input" 
                                  />
                                  Bloquear
                              </label>
                              </div>
                          </div>

                          <!--<div class="p-2 flex flex-col">
                              <div class="flex flex-1 border-gray-300 p-2 text-gray-900">
                              <fwb-textarea
                                  v-model="aboute_me"
                                  :rows="4"
                                  :cols="100"
                                  label="Sobre mí"
                                  placeholder="Escríbe una descripción sobre ti para que te conozcan más tus prospectos"
                                  class="w-full text-box"
                              />
                              </div>
                          </div>
                          Cargo (Visible solo si es Admin o Manager) 
                          <div class="col-md-6" v-if="isRoleAdminOrManager">
                              <div class="mb-3">
                                  <label class="form-label">Cargo</label>
                                  <select class="form-control btn-square" v-model="user.position_id">
                                  <option value="0">Selecciona un cargo</option>
                                  <option v-for="position in positions" :key="position.id" :value="position.id">
                                      {{ position.name }}
                                  </option>
                                  </select>
                              </div>
                              </div>-->
                          <div class="p-2 flex flex-col">
                              <div class="flex flex-1 justify-end items-end border-gray-300 p-2 text-gray-900">
                              <fwb-button 
                                  class="bg-tuin-100 hover:bg-tuin-100" 
                                  size="xl"
                                  @click="saveData()"
                              >
                                  Actualizar Perfil
                              </fwb-button>
                              </div>
                      </div>
                      <div v-if="successMessage" class="user-alert">
                          <div class="user-alert-content">
                          <div class="user-alert-text">
                              {{ successMessage }}
                          </div>
                          </div>
                          <div class="w-4 h-4 relative"></div>
                      </div>
                      <head>
                              <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                      </head>
                      </div>
                  </div>
                  <div v-if="activeTab === 'social'">
                      <social-networks-form 
                        :company-id="companyId" 
                        @social-data-updated="handleSocialDataUpdate"
                      ></social-networks-form>
                  </div>
                  <div v-if="activeTab === 'propiedades'">
                      <Properties-list 
                        :company-id="companyId" 
                        @social-data-updated="handleSocialDataUpdate"
                      ></Properties-list >
                  </div>
              </div>
          </div>
      </div>
  </div> 
</template>

<script setup>
import { FwbInput, FwbButton } from "flowbite-vue";
import { ref, computed, onMounted } from "vue";
import { es } from 'date-fns/locale';
import VueDatePicker from "@vuepic/vue-datepicker";
import axios from "axios";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import 'vue-toastification/dist/index.css';
import Loader from '@/components/loaderComponent.vue';
import defaultProfileImage from '@/assets/imgs/1.png';
import SocialNetworksForm from '@/components/prospectos/AdvisorProspectComponent.vue'; // Import the new component
import PropertiesList from '@/components/prospectos/PropertiesProspectosComponent.vue'; // Import the new component
// Obtener la tienda de Vuex
const store = useStore();
const isLoading = ref(false); // Inicializamos isLoading
const activeTab = ref('general'); // Default active tab
import { useRouter } from "vue-router";
let session = computed(() => store.getters.getUserSession);
const route = useRoute();

let selectedRoles = ref([]);
let router = useRouter();
// Variables reactivas
let name = ref(null);
let birthday = ref();
let email = ref();
let aboute_me = ref();
let phone = ref();
let  imageSrc = ref(null);
let  blockUser = ref(false);
let advisor_id = ref();
let userId = computed(() => route.params.id);
// Computed que devuelve la URL de la imagen a mostrar
let last_name = ref();
let last_second_name = ref();
let step = ref(1);
let profile = ref();
let user = ref({ company_id: null });
let cargos = ref([]); // Declaración de cargos
let dic_advisors = ref([]);
const successMessage = ref('');
// Formato de fecha
const format = (birthday) => {
  if (!birthday) return "";
  const day = birthday.getDate();
  const month = birthday.getMonth() + 1;
  const year = birthday.getFullYear();
  return `${day}/${month}/${year}`;
};
const handleSocialDataUpdate = (socialData) => {
      // You can add logic here to handle social data if needed
      console.log('Social data updated:', socialData);
  };
console.log(imageSrc)
// Obtener perfil

async function getProfile() {
  isLoading.value = true; // Marca que está cargando
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`
      }
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${userId.value}`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
      return; // Finaliza la función si se limpia la sesión
    }

    if (response.status === 200) {
      const data = response.data.resp.info;

      // Asigna valores básicos, con validación por si faltan
      profile.value = data || {};
      name.value = data.name || '';
      last_name.value = data.last_name || '';
      last_second_name.value = data.second_last_name || '';
      email.value = data.email || '';
      phone.value = data.phone || '';
      aboute_me.value = data.about_me || '';
      birthday.value = data.birthday || '';
      advisor_id.value = data.broker_id || '';
      // Asigna la imagen de avatar
      imageSrc.value = data.avatar 
        ? `${process.env.VUE_APP_API_BASE_URL}/path/to/avatar/${data.avatar}` 
        : '/path/to/default-avatar.png'; // Usa un avatar predeterminado

      console.log("Avatar URL:", imageSrc.value);

      // Si roles existe, mapea los IDs; de lo contrario, usa un arreglo vacío
      selectedRoles.value = Array.isArray(data.roles) 
        ? data.roles.map(role => role.id) 
        : [];
    }
  } catch (error) {
    if (error.response) {
      console.error(`Error ${error.response.status}: ${error.response.data.message}`);
    } else if (error.request) {
      console.error("Sin respuesta del servidor. Verifica la conexión.");
    } else {
      console.error("Error en la solicitud:", error.message);
    }
  } finally {
    isLoading.value = false; // Finaliza el estado de carga
  }
}

async function getAdvisors() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/get_All_advisors`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    // Corrected mapping
    dic_advisors.value = response.data.resp.map((item) => ({
      id: item.id,
      name: `${item.name} ${item.last_name}` // Full name for display
    }));
  }
}


async function updateProfileImage(event) {
    const file = event.target.files[0];
    if (file) {
      // Similar al de portada, puedes cargar la imagen en tu servidor o mostrarla localmente
      const reader = new FileReader();
      reader.onload = () => {
        imageSrc.value = reader.result;   // Actualiza la imagen en la vista
        console.log(imageSrc)
      };
      reader.readAsDataURL(file);  // Convierte la imagen a base64
    }
}



// Llama a la función para obtener los roles al montar el componente
onMounted(async () => {
  await getAdvisors();
  await getProfile();
});


// Función para guardar datos
async function saveData() {
  // Establecer el valor de step
  if (session.value.step < 3) {
    step.value = 1;
  } else {
    step.value = session.value.step;
  }

  // Datos generales a enviar en la primera solicitud
  let params = {
    name: name.value,
    birthday: birthday.value,
    email: email.value,
    phone: phone.value,
    last_name: last_name.value,
    second_last_name: last_second_name.value,
    broker_id: advisor_id.value,
    blockUser: blockUser.value ? 1 : 0, // Si el usuario está bloqueado
  };

  console.log('params:', params);

  try {
    // Configuración para la solicitud
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    // Decidir la URL de la solicitud en base a userId.value
    const url = userId.value
      ? `${process.env.VUE_APP_API_BASE_URL}/lead/update/${userId.value}`
      : `${process.env.VUE_APP_API_BASE_URL}/lead/add`;

    // Primer solicitud para guardar los datos generales
    const response = await axios({
      method: userId.value ? 'put' : 'post', // Usar PUT si es actualización, POST si es creación
      url,
      data: params,
      ...options,
    });

    // Verificar si los datos generales se guardaron correctamente
    if (response.status == 200) {
      showToast('Datos guardados correctamente');
      console.log(userId.value);

      // Si el paso es menor que 3, redirigir y actualizar el perfil
      if (session.value.step < 3) {
        session.value.step = 1;
        router.push({ name: "" });
        getProfile();
      }

      // Verificar si hay una imagen de perfil y enviarla
      if (imageSrc.value) {
        // Crear un objeto FormData para enviar la imagen y el email
        let formData = new FormData();
        formData.append('email', email.value); // Agregar el email al FormData
        formData.append('user_id', userId.value);
        // Verificar si la imagen es un archivo o Base64
        if (imageSrc.value instanceof File) {
          console.log('Profile Avatar (File):', imageSrc.value);
          formData.append('profile_avatar', imageSrc.value);
        } else if (
          typeof imageSrc.value === 'string' &&
          imageSrc.value.startsWith('data:image')
        ) {
          console.log('Profile Avatar (Base64):', imageSrc.value);
          const profileAvatarFile = base64ToFile(
            imageSrc.value,
            'profile_avatar.jpg'
          );
          formData.append('profile_avatar', profileAvatarFile);
        }

        // Enviar la imagen de perfil
        const imageResponse = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/broker/profile/update-account`,
          formData,
          options
        );

        // Verificar si la imagen se guardó correctamente
        if (imageResponse.status == 200) {
          showToast('Imagen de perfil guardada correctamente');
        } else {
          showToast('Error al guardar la imagen de perfil');
        }
      }
    }
  } catch (error) {
    console.error('Error al guardar los datos:', error);
    showToast('Error al guardar los datos');
  }
}

const base64ToFile=(base64Data, filename)=> {
  let arr = base64Data.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
const showToast = (message) => {
  successMessage.value = message;
  setTimeout(() => {
    successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  }, 3000);
}

</script>


<style scoped>
  /* Label personalizado */
  ::v-deep .custom-label label,
  ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
  }

  /* Fondo del body */
  body {
    background-color: #ffffff !important;
  }

  /* Imagen de usuario */
  .user-image {
    position: relative;
    margin-top: -60px;
    margin-bottom: 1rem;
  }
  .avatar {
    @apply rounded-full w-32 h-32 border-4 border-white inline-block overflow-hidden;
  }

  /* Roles en contenedor flexible */
  .roles-container {
    @apply flex flex-wrap gap-4;
  }

  /* Checkbox seleccionado */
  .form-check-input:checked {
    @apply bg-pink-500 border-pink-500;
  }
</style>
